export default __webpack_public_path__ + "static/media/plan4-col1-img.745d7d2c.svg";